<script setup lang="ts">
import { CatIcon } from '@lucide/vue';
import { Button } from '@/components/ui/button';
import { useMascotStore } from '@/stores/mascot';

const mascot = useMascotStore();
</script>

<template>
  <Button
    v-if="mascot.available"
    variant="ghost"
    size="icon-sm"
    data-mascot-header-home
    class="w-11"
    :aria-label="mascot.visible ? 'Спрятать кошку' : 'Позвать кошку'"
    :aria-pressed="mascot.visible"
    :data-tip="mascot.visible ? 'Спрятать кошку' : 'Позвать кошку'"
    :class="{ 'text-primary': mascot.visible, 'ring-2 ring-primary/50 bg-primary/10': mascot.carrying }"
    @click="mascot.setHidden(mascot.visible)"
  >
    <CatIcon />
  </Button>
</template>
